"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BC_BUTTON_GROUP = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.BC_BUTTON_GROUP = Object.freeze({
    INPUT: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-group-input"),
    INDICATOR: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-indicator"),
    CONTAINER: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-group-container"),
    DEFAULT_INDICATOR_COLOR: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-default-indicator"),
    BLACK_INDICATOR_COLOR: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-black-indicator"),
    BLACK_INDICATOR_INPUT: "blackActiveIndicator",
    DEFAULT_INDICATOR_INPUT: "defaultActiveIndicator",
    SMALL: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-group-font-size-small"),
    X_SMALL: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-group-font-size-xsmall"),
    DEFAULT: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-group-font-size-default"),
    SHADOW: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-group-container-shadow"),
    NO_SHADOW: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-group-container-no-shadow"),
    CHECKED_BUTTON_GROUP: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-position-selected"),
    LABEL_DISABLED: "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-group-disabled-label"),
    INIT_TIMEOUT: 300,
});
